import { useState } from 'react';
import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import { setRiskResult } from '@/features/questionnaire/model/questionnaireSlice';
import { requestRiskCalculation, getRiskStatus } from '@/features/questionnaire/api/questionnaireApi';

export const useRiskAssessment = () => {
    const dispatch = useAppDispatch();
    const [progress, setProgress] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const riskResult = useAppSelector((state) => state.questionnaire.riskResult);

    const requestRiskAssessment = async (instance_id: number) => {
        if (riskResult) {
            console.log('[useRiskAssessment] ❌ Пропущен запрос: результат уже есть в Redux');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const { request_id } = await requestRiskCalculation(instance_id);

            let pollingProgress = 30;
            setProgress(pollingProgress);

            const poll = async () => {
                try {
                    const res = await getRiskStatus(request_id);
                    setProgress(Math.min(pollingProgress + 10, 95));

                    if (res.status === 'completed') {
                        dispatch(setRiskResult(res));
                        setProgress(100);
                        setLoading(false);
                        return;
                    }

                    setTimeout(poll, 2000);
                } catch (err) {
                    setError('Ошибка при получении оценки рисков');
                    setLoading(false);
                }
            };

            poll();
        } catch (err) {
            console.error('Ошибка при запросе оценки рисков:', err);
            setError('Ошибка при запуске оценки рисков');
            setLoading(false);
        }
    };

    return { requestRiskAssessment, loading, progress, error };
};
